<template>
  <tk-container class="maintain" :status="status" @refresh="initData">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      维修维护
    </tkui-header>
    <div class="body">
      <div class="item" v-for="(item, index) in records" :key="index">
        <tk-flex between middle class="record">
          <h2 class="name">{{item.type}}</h2>
          <p class="time" v-if="item.createdAt">{{item.createdAt.split('T')[0]}}</p>
        </tk-flex>
        <p class="content">维系人：{{item.worker}}</p>
        <p class="content">{{item.content}}</p>
      </div>
    </div>
    <div slot="cover">
      <tk-flex middle center class="addBtn" @click.native="add">
        <tk-icon style="height: 18px;margin-right: 3px;margin-top: -2px;">plus</tk-icon>
        <span>添加记录</span>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        status: false,
        records: []
      }
    },
    computed: {
      machine () {
        return this.$store.state.machine
      }
    },
    created () {
      this.initData()
    },
    hasFlash (flash) {
      this.initData()
    },
    methods: {
      back () {
        this.$back()
      },
      async initData () {
        try {
          this.status = 'loading'
          let records = await this.$tkParse.getList('/classes/repair', {
            'params': {
              'order': '-createdAt',
              'where': {
                'machine': this.machine.objectId
              }
            }
          })
          this.records = records
          this.status = false
        } catch (e) {
          this.status = false
          this.$tkGlobal.toast.add('获取数据失败')
        }
      },
      add () {
        this.$push('/addrecord')
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .body{
    .item{
      background: #ffffff;
      padding: 15px;
      margin-bottom: 2px;
      .record{
        margin-bottom: 5px;
        .name{
          color: #333333;
          font-size: 16px;
        }
        .time{
          color: #666666;
          font-size: 12px;
        }
      }
      .content{
        color: #666666;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .addBtn{
    position: fixed;
    width: 134px;
    height: 34px;
    border-radius: 17px;
    background: #ffffff;
    color: #0091ff;
    bottom: 30px;
    left: 50%;
    margin-left: -67px;
    line-height: 34px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    box-shadow:0px 4px 5px rgba(31,131,207,0.15);
  }
</style>



// WEBPACK FOOTER //
// src/page/app/maintain/maintain.vue